export default __webpack_public_path__ + "static/media/pension.bg.1fbd311c.svg";